import { useTranslation } from 'react-i18next';

const features = [
  { key: 'why.f1', icon: 'ri-refresh-line' },
  { key: 'why.f2', icon: 'ri-shield-check-line' },
  { key: 'why.f3', icon: 'ri-grid-line' },
  { key: 'why.f4', icon: 'ri-compass-3-line' },
  { key: 'why.f5', icon: 'ri-scales-3-line' },
  { key: 'why.f6', icon: 'ri-sparkling-2-line' },
];

export default function WhyChooseUs() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">
            {t('why.badge')}
          </span>
          <h2 className="mt-3 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            {t('why.title')}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            {t('why.subtitle')}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((f) => (
            <div
              key={f.key}
              className="rounded-xl border border-background-200/70 bg-white p-6 transition-all hover:-translate-y-0.5 hover:shadow-sm"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
                <i className={`${f.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-900">
                {t(`${f.key}.title`)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {t(`${f.key}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}